export default function generateLogoutUrl(location) {
    const logoutUrl = new URL(process.env.LOGOUT_URL); // eslint-disable-line no-undef

    logoutUrl.searchParams.append('logout_target', location.toString());

    return logoutUrl.toString();
}
